var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarCashBanner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 201,
    viewBox: "-70 -60 335 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159 141H43.6603L0 12H115.34L159 141Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 25H0V141H116V25Z",
    fill: "#6BB6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116 12H0V25H116V12Z",
    fill: "#006EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 26H0V25H116V26Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21C21.1046 21 22 20.1046 22 19C22 17.8954 21.1046 17 20 17C18.8954 17 18 17.8954 18 19C18 20.1046 18.8954 21 20 21Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21C46.1046 21 47 20.1046 47 19C47 17.8954 46.1046 17 45 17C43.8954 17 43 17.8954 43 19C43 20.1046 43.8954 21 45 21Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21C71.1046 21 72 20.1046 72 19C72 17.8954 71.1046 17 70 17C68.8954 17 68 17.8954 68 19C68 20.1046 68.8954 21 70 21Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21C96.1046 21 97 20.1046 97 19C97 17.8954 96.1046 17 95 17C93.8954 17 93 17.8954 93 19C93 20.1046 93.8954 21 95 21Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 94.036L17.1666 100L14 96.7635L15.0138 95.7274L17.1665 97.9275L21.986 93L23 94.036Z",
    fill: "#00EC25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116 40L93 62.2346L103.104 72L116 59.5344V40Z",
    fill: "#006EF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27 114H10V131H27V114Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 61H54V79H35V61ZM35.7851 61.7438V78.2562H53.2149V61.7438H35.7851Z",
    fill: "#006EF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 35H80V52H62V35ZM62.7438 35.7025V51.2975H79.2562V35.7025H62.7438Z",
    fill: "#006EF5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 61H107V79H88V61ZM88.7851 61.7438V78.2562H106.215V61.7438H88.7851Z",
    fill: "#006EF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 87H54V105H35V87ZM35.7851 87.7438V104.256H53.2149V87.7438H35.7851Z",
    fill: "#006EF5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 61H27V79H9V61ZM9.7438 61.7438V78.2562H26.2562V61.7438H9.7438Z",
    fill: "#006EF5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 113H54V132H35V113ZM35.7851 113.785V131.215H53.2149V113.785H35.7851Z",
    fill: "#006EF5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189 60H173V76H189V60Z",
    fill: "#006EF5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166 60L180.5 43L195 60",
    fill: "#006EF5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.771903C14.9035 0.771903 10.7719 4.90346 10.7719 10C10.7719 15.0965 14.9035 19.2281 20 19.2281C25.0965 19.2281 29.2281 15.0965 29.2281 10C29.2281 4.90346 25.0965 0.771903 20 0.771903ZM10 10C10 4.47715 14.4772 0 20 0C25.5228 0 30 4.47715 30 10C30 15.5228 25.5228 20 20 20C14.4772 20 10 15.5228 10 10Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 0.771903C39.9035 0.771903 35.7719 4.90346 35.7719 10C35.7719 15.0965 39.9035 19.2281 45 19.2281C50.0965 19.2281 54.2281 15.0965 54.2281 10C54.2281 4.90346 50.0965 0.771903 45 0.771903ZM35 10C35 4.47715 39.4772 0 45 0C50.5228 0 55 4.47715 55 10C55 15.5228 50.5228 20 45 20C39.4772 20 35 15.5228 35 10Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5 0.771903C65.6583 0.771903 61.7333 4.90346 61.7333 10C61.7333 15.0965 65.6583 19.2281 70.5 19.2281C75.3417 19.2281 79.2667 15.0965 79.2667 10C79.2667 4.90346 75.3417 0.771903 70.5 0.771903ZM61 10C61 4.47715 65.2533 0 70.5 0C75.7467 0 80 4.47715 80 10C80 15.5228 75.7467 20 70.5 20C65.2533 20 61 15.5228 61 10Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5 0.771903C90.6583 0.771903 86.7333 4.90346 86.7333 10C86.7333 15.0965 90.6583 19.2281 95.5 19.2281C100.342 19.2281 104.267 15.0965 104.267 10C104.267 4.90346 100.342 0.771903 95.5 0.771903ZM86 10C86 4.47715 90.2533 0 95.5 0C100.747 0 105 4.47715 105 10C105 15.5228 100.747 20 95.5 20C90.2533 20 86 15.5228 86 10Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35H36V52H53V35Z",
    fill: "#091F83"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 35H54V52H35V35ZM35.7851 35.7025V51.2975H53.2149V35.7025H35.7851Z",
    fill: "#006EF5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 35H107V52H88V35ZM88.7851 35.7025V51.2975H106.215V35.7025H88.7851Z",
    fill: "#006EF5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 61H80V79H62V61ZM62.7438 61.7438V78.2562H79.2562V61.7438H62.7438Z",
    fill: "#006EF5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88H10V105H27V88Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 87H27V105H9V87ZM9.7438 87.7438V104.256H26.2562V87.7438H9.7438Z",
    fill: "#006EF5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 87H80V105H62V87ZM62.7438 87.7438V104.256H79.2562V87.7438H62.7438Z",
    fill: "#006EF5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 87H107V105H88V87ZM88.7851 87.7438V104.256H106.215V87.7438H88.7851Z",
    fill: "#006EF5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 113H27V132H9V113ZM9.7438 113.785V131.215H26.2562V113.785H9.7438Z",
    fill: "#006EF5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 113H80V132H62V113ZM62.7438 113.785V131.215H79.2562V113.785H62.7438Z",
    fill: "#006EF5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 113H107V132H88V113ZM88.7851 113.785V131.215H106.215V113.785H88.7851Z",
    fill: "#006EF5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.955657C15.0059 0.955657 10.9557 5.00587 10.9557 10C10.9557 14.9941 15.0059 19.0443 20 19.0443V20C14.4781 20 10 15.5219 10 10C10 4.47808 14.4781 0 20 0C25.5219 0 30 4.47808 30 10H29.0443C29.0443 5.00587 24.9941 0.955657 20 0.955657Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 0.955657C40.0059 0.955657 35.9557 5.00587 35.9557 10C35.9557 14.9941 40.0059 19.0443 45 19.0443V20C39.4781 20 35 15.5219 35 10C35 4.47808 39.4781 0 45 0C50.5219 0 55 4.47808 55 10H54.0443C54.0443 5.00587 49.9941 0.955657 45 0.955657Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 0.955657C65.0059 0.955657 60.9557 5.00587 60.9557 10C60.9557 14.9941 65.0059 19.0443 70 19.0443V20C64.4781 20 60 15.5219 60 10C60 4.47808 64.4781 0 70 0C75.5219 0 80 4.47808 80 10H79.0443C79.0443 5.00587 74.9941 0.955657 70 0.955657Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5 0.955657C90.7556 0.955657 86.9079 5.00587 86.9079 10C86.9079 14.9941 90.7556 19.0443 95.5 19.0443V20C90.2542 20 86 15.5219 86 10C86 4.47808 90.2542 0 95.5 0C100.746 0 105 4.47808 105 10H104.092C104.092 5.00587 100.244 0.955657 95.5 0.955657Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1323 62L103 71.8671L89 76L93.1323 62Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M155.311 0.00777811L147.768 7.55078L157.58 17.3625L165.123 9.81948L155.311 0.00777811Z",
    fill: "#006EF5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M147.766 7.55135L93.2236 62.0938L103.035 71.9054L157.578 17.3631L147.766 7.55135Z",
    fill: "#091F83"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M116 84H83.6873C83.6873 90.8253 78.0066 96.3561 71 96.3561V119.644C78.0066 119.644 83.6873 125.175 83.6873 132H116V84Z",
    fill: "#006EF5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116 92C125.389 92 133 99.6107 133 109C133 118.389 125.389 126 116 126",
    fill: "#6BB6FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116 126C106.611 126 99 118.389 99 109C99 99.6107 106.611 92 116 92",
    fill: "#F0F8FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173 76H62V141H173V76Z",
    fill: "#00EC25"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M116 76H62V141H116V76Z",
    fill: "#091F83"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71 119.644V96.3561C77.8862 96.3561 83.4694 90.8253 83.4694 84H150.531C150.531 90.8253 156.114 96.3561 163 96.3561V119.644C156.114 119.644 150.531 125.175 150.531 132H83.4694C83.4694 125.175 77.8862 119.644 71 119.644Z",
    fill: "#F0F8FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 118V99H116V118H115Z",
    fill: "#232323"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 105.025C110 102.558 112.039 101 114.35 101H114.946V102.596H114.35C112.744 102.596 111.611 103.612 111.611 105.025C111.611 106.422 112.728 107.404 114.35 107.404H115V109H114.35C112.059 109 110 107.507 110 105.025Z",
    fill: "#232323"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 101H116.746C119.094 101 121 102.79 121 105H119.424C119.424 103.609 118.224 102.481 116.746 102.481H116V101Z",
    fill: "#232323"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 107H116.65C118.941 107 121 108.68 121 111.472C121 114.247 118.961 116 116.65 116H116.054V114.205H116.65C118.256 114.205 119.389 113.062 119.389 111.472C119.389 109.9 118.272 108.795 116.65 108.795H116V107Z",
    fill: "#232323"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.254 116C111.906 116 110 113.763 110 111H111.576C111.576 112.739 112.776 114.148 114.254 114.148H115V116H114.254Z",
    fill: "#232323"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154 52H137V51H154V52Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154 58H137V56H154V58Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarCashBanner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CalendarCashBanner.3573cddd29e2b485fe0b17e5240f9111.svg";